import { useRecoilValue } from 'recoil';
import { SubHeadingOne } from 'components/core';
import { builderAnswersState, builderEditsState } from 'states';
import { describe } from 'helpers/kpiBuilder/engine';

// "In plain words": the question being answered, without any query.
export const BuilderSummary = () => {
  const answers = useRecoilValue(builderAnswersState);
  const edits = useRecoilValue(builderEditsState);
  const edited = edits.query !== null || edits.config !== null;

  return (
    <div className="border rounded p-3 h-100 bg-white">
      <SubHeadingOne title="In plain words" />
      <p className="mt-2 mb-0">{describe(answers)}</p>
      {edited && <p className="small text-warning mt-2 mb-0">The query or config was edited by hand, so this may no longer match what is saved.</p>}
    </div>
  );
};
